// Products that aren't live on prod yet (Packages) show only when this build
// talks to the dev API (directly or through a devtunnel), or when it runs
// locally or is itself served through a devtunnel. Prod's REACT_APP_BASEURL is
// the prod API, so prod hides them without needing an extra env var.
const DEVTUNNEL_HOST = /\.devtunnels\.ms/;

export const isDevEnv =
  /\.dev\.tramango\.com/.test(process.env.REACT_APP_BASEURL || "") ||
  DEVTUNNEL_HOST.test(process.env.REACT_APP_BASEURL || "") ||
  DEVTUNNEL_HOST.test(window.location.hostname) ||
  window.location.hostname === "localhost";
